import { render, staticRenderFns } from "./RegisterProfileModal.vue?vue&type=template&id=752cb657&scoped=true&"
import script from "./RegisterProfileModal.vue?vue&type=script&lang=ts&"
export * from "./RegisterProfileModal.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterProfileModal.vue?vue&type=style&index=0&id=752cb657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752cb657",
  null
  
)

export default component.exports